import api from '@/lib/axios'

export interface Partner {
    _id: string
    name: string
    imageUrl?: string
    orderIndex: number
    isActive: boolean
}

export const partnerService = {
    getPartners: async (): Promise<Partner[]> => {
        const response = await api.get('/partners')
        return response.data
    },

    createPartner: async (data: Omit<Partner, '_id'>): Promise<Partner> => {
        const response = await api.post('/partners', data)
        return response.data
    },

    updatePartner: async (id: string, data: Partial<Partner>): Promise<Partner> => {
        const response = await api.put(`/partners/${id}`, data)
        return response.data
    },

    deletePartner: async (id: string): Promise<void> => {
        await api.delete(`/partners/${id}`)
    }
}
